import React, { useEffect , useState } from "react";
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { API_BASE_URL } from "../../Variables";

import "../../components/ListView/ListView.css";

import "./SearchPage.css";
import back from '../../assets/images/back.svg';
import BookDisplay from "../../components/BookDisplay";
import Pagination from '../../components/Pagination';
import BookDetailsModal from "../../components/BookDetailsModal/BookDetailsModal.js";

function SearchPage() {
  const { query } = useParams();
  const navigate = useNavigate();

  // Search results states
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [sort, setSort] = useState("");
  const [filter, setFilter] = useState("");

  // Book Details Modal states
  const [displayBookDetailsModal, setDisplayBookDetailsModal] = useState(false);
  const [selectedBookId, setSelectedBookId] = useState(null);

  // Pagination states
  const [offset, setOffset] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const limit = 20;
  const currentPage = Math.floor(offset / limit) + 1;

  // Function to handle back button click
  const handleBackClick = () => {
    navigate(-1);
  };

  const handleSortChange = (event) => {
    setSort(event.target.value);
    setOffset(0);
  }

  const handleFilterChange = (event) => {
    setFilter(event.target.value);
    setOffset(0);
  }

  const handleBookClick = (bookId) => {
    setSelectedBookId(bookId);
    setDisplayBookDetailsModal(true);
  };

  // Fetch search results based on query
  useEffect(() => {
    
    const fetchSearchResults = async () => {
      setLoading(true);
      setError(null);

      let newQuery = "";
      if(filter !== "") {
        newQuery = filter + query;
      }

      const params = {
        q: newQuery? newQuery : query,
        startIndex: offset,
        maxResults: limit,
      };

      // Add sorting parameter if selected
      if (sort) {
        params.orderBy = sort;
      }
  
      try {
        const response = await axios.get(`${API_BASE_URL}/books-api`, {
          params
        });

        setSearchResults(response.data.items || [])
        setTotalPages(Math.ceil(response.data.totalItems / limit)); 

      } catch (error) {
        setLoading(false);
        if(error && error.response && error.response.data) {
          setError(error.response.data.message + ". Please try again later. ");
        }
        else {
          setError("Failed to load results. Please try again later. ");
        }
        setSearchResults([]);
      } finally {
        setLoading(false); 
      }
    };

    if(!query) {
      setError("No search query provided.");
      return;
    }

    fetchSearchResults();
    
  }, [query, offset, limit, sort, filter]); 

  useEffect(() => {

    if(!query) {
      setError("No search query provided.");
    }

    setOffset(0);
  }, [query]); 

  return (
    <div className="list-view">
      <div className="search-page-header">
        <div className="list-preview-header">
          <img src={back} alt="Back" className="back-button" onClick={handleBackClick} />
          <h2>Search Results:   <span className="search-query">{query}</span></h2>
        </div>

        <div className="search-filters">
          <select value={filter} onChange={handleFilterChange}>
            <option value="">Filter by</option>
            <option value="intitle:">Title</option>
            <option value="inauthor:">Author</option>
            <option value="subject:">Subject</option>
          </select>

          <select value={sort} onChange={handleSortChange}>
            <option value="">Sort by</option>
            <option value="relevance">Relevance</option>
            <option value="newest">Newest</option>
          </select>
        </div>
      </div>

      <div className="list-view-display">
        {loading ? (
          <p className="loading">Loading...</p>
        ): searchResults.length > 0 ? (
          searchResults.map((book, index) => (
            <BookDisplay key={index} book={book} onBookClick={handleBookClick}  />
          ))
        ) : !error ? (
          <p>No results found.</p>
        ): <p className="error">{error}</p>
        }
      </div>

      {totalPages > 0 && (
        <Pagination totalPages={totalPages} setOffset={setOffset} limit={limit} currentPage={currentPage} />
      )}

      {/* Book Details Modal */}
      {displayBookDetailsModal && (
        <BookDetailsModal
          setDisplayBookDetailsModal={setDisplayBookDetailsModal}
          bookId={selectedBookId}
        />
      )}
    </div>
  );
}

export default SearchPage;

